import React from 'react';
import './Footer.scss';

const Footer = () => {
  return (
    <footer className="copyright-footer">
      <p>&copy; 2024 Victor Gago. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
